import { ReactNode } from 'react';
import { components } from '@api/play-account/generated';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { HeavyModalCard } from '@ui/components/HeavyModalCard/HeavyModalCard';
import { Tabs } from '@ui/components/Tabs';

import { ClubDto } from '@features/shared/api/typings';
import { PlayerClubs } from '@features/user/ui/PlayerClubs/PlayerClubs';
import { PlayerTournaments } from '@features/user/ui/PlayerTournaments/PlayerTournaments';

import styles from './PlayerClubsAndTournamentsFull.module.css';

type TabValue = 'upcoming' | 'finished';

const TOURNAMENT_TABS: { value: TabValue; label: ReactNode }[] = [
  { value: 'upcoming', label: 'предстоящие' },
  { value: 'finished', label: 'прошедшие' },
];

type Props = {
  clubs: ClubDto[];
  totalTournamentsCount?: number;
  tournaments: components['schemas']['TournamentShortDto'][];
  onClose: () => void;
  tournamentTab: TabValue;
  onTabChange: (newTab: TabValue) => void;
  hasMoreTournaments: boolean;
  loadMoreTournaments: () => void;
};
export function PlayerClubsAndTournamentsFull({
  clubs,
  totalTournamentsCount,
  tournaments,
  onClose,
  tournamentTab,
  onTabChange,
  hasMoreTournaments,
  loadMoreTournaments,
}: Props) {
  const isMobile = useMediaQuery() === 'mobile';
  const isTablet = useMediaQuery() === 'tablet';

  return (
    <HeavyModalCard preset="black" header="Мои клубы и турниры" open onBack={onClose}>
      <div className={styles.content}>
        <div className={styles.clubs}>
          <div className={styles.title}>
            Мои клубы
            <span className={styles.itemCount}>{clubs.length}</span>
          </div>
          <PlayerClubs preset={isMobile || isTablet ? 'm' : 'l'} clubs={clubs} />
        </div>

        <div className={styles.tournaments}>
          <div className={styles.title}>
            Мои турниры
            {totalTournamentsCount !== undefined && (
              <span className={styles.itemCount}>{totalTournamentsCount}</span>
            )}
          </div>

          <Tabs
            className={styles.tabs}
            tabs={TOURNAMENT_TABS}
            onChange={onTabChange}
            value={tournamentTab}
            heavy
          />

          <PlayerTournaments
            tournaments={tournaments}
            clubs={clubs}
            hasMore={hasMoreTournaments}
            loadMore={loadMoreTournaments}
            isUpcoming={tournamentTab === 'upcoming'}
          />
        </div>
      </div>
    </HeavyModalCard>
  );
}
